import { useCallback, useRef } from 'react'

/**
 * 一覧のページ送り・フィルタ・ソート後に、スクロール位置を先頭へ戻すための ref / 関数。
 * window ではなく overflow コンテナ向け。
 */
export const useScrollToTop = <T extends HTMLElement = HTMLDivElement>() => {
  const scrollRef = useRef<T>(null)

  const scrollToTop = useCallback(() => {
    scrollRef.current?.scrollTo(0, 0)
  }, [])

  return { scrollRef, scrollToTop }
}
